import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { CoreContext } from "../context";
import {
  EditUnavailabilityError,
  Identifiable,
  Unavailability,
} from "@planzone/dto";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  error: EditUnavailabilityError;
  editUnavailability(
    request: Boundaries["editUnavailability"]["request"],
  ): void;
}

function useEditUnavailability(
  unavailability: Identifiable<Unavailability>,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isEditUnavailabilityRequestPending(unavailability),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isEditUnavailabilityRequestSuccess(unavailability),
    ),
    isRequestFailure: useSelector(() =>
      selector.isEditUnavailabilityRequestFailure(unavailability),
    ),
    error: useSelector(() =>
      selector.getEditUnavailabilityError(unavailability),
    ),
    editUnavailability: core.editUnavailability,
  };
}

export { useEditUnavailability };
